import React from 'react';

const selectStyles = "px-4 py-2.5 h-11 w-full border border-gray-200 dark:border-gray-700 rounded-md bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 focus:border-sky-500 focus:ring-1 focus:ring-sky-500 disabled:bg-gray-50 disabled:text-gray-500 disabled:border-gray-200 text-sm transition-colors appearance-none bg-no-repeat bg-[right_0.5rem_center] bg-[length:1.5em_1.5em] bg-[url('data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2020%2020%22%20fill%3D%22%236B7280%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20d%3D%22M10%203a1%201%200%2001.707.293l3%203a1%201%200%2001-1.414%201.414L10%205.414%207.707%207.707a1%201%200%2001-1.414-1.414l3-3A1%201%200%200110%203zm-3.707%209.293a1%201%200%20011.414%200L10%2014.586l2.293-2.293a1%201%200%20011.414%201.414l-3%203a1%201%200%2001-1.414%200l-3-3a1%201%200%20010-1.414z%22%20clip-rule%3D%22evenodd%22%2F%3E%3C%2Fsvg%3E')] pr-10";

const filterUsersByRole = (users, roles, area) =>
  users
    .filter(user => {
      if (user.isActive === false) return false;
      if (!roles.includes(user.role)) return false;
      if (area && user.areas && Array.isArray(user.areas)) {
        const propertyArea = area.toUpperCase();
        const userAreas = user.areas.map(a => a.toUpperCase());
        return userAreas.includes(propertyArea);
      }
      return true;
    })
    .sort((a, b) => {
      const nameA = a.name || `${a.firstName || ''} ${a.lastName || ''}`.trim() || a.email;
      const nameB = b.name || `${b.firstName || ''} ${b.lastName || ''}`.trim() || b.email;
      return nameA.localeCompare(nameB);
    });

const getUserDisplayName = (user) =>
  user.name || `${user.firstName || ''} ${user.lastName || ''}`.trim() || user.email;

export default function AutoAssign({
  cleaningAssignedUserId,
  inspectionAssignedUserId,
  walkthroughAssignedUserId,
  area,
  allUsers,
  onInputChange,
  showHeader = true,
}) {
  const cleaningUsers = filterUsersByRole(allUsers, ['HOUSEKEEPER', 'HOUSEKEEPER_MANAGER'], area);
  const inspectionUsers = filterUsersByRole(allUsers, ['INSPECTOR', 'ADMIN', 'PROPERTY_MANAGER'], area);
  const walkthroughUsers = filterUsersByRole(allUsers, ['PROPERTY_MANAGER', 'INSPECTOR'], area);

  return (
    <>
      {showHeader && (
        <div className="px-4 py-5 sm:px-6 bg-gray-50 border-b border-gray-200">
          <h3 className="text-lg font-medium leading-6 text-gray-900">Auto-Assignment Settings</h3>
          <p className="mt-1 text-sm text-gray-500">
            Configure which users should be automatically assigned to jobs for this property
          </p>
        </div>
      )}
      <div className={showHeader ? 'p-6' : ''}>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700">Cleaning Jobs</label>
            <select
              name="cleaningAssignedUserId"
              value={cleaningAssignedUserId}
              onChange={onInputChange}
              className={selectStyles}
            >
              <option value="">Select a user</option>
              {cleaningUsers.map((user) => (
                <option key={user.id} value={user.id}>
                  {getUserDisplayName(user)} - {user.role}
                </option>
              ))}
            </select>
            <p className="mt-1 text-xs text-gray-500">
              Assign cleaning jobs to housekeepers or housekeeper managers
            </p>
          </div>

          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700">Inspections</label>
            <select
              name="inspectionAssignedUserId"
              value={inspectionAssignedUserId}
              onChange={onInputChange}
              className={selectStyles}
            >
              <option value="">Select a user</option>
              {inspectionUsers.map((user) => (
                <option key={user.id} value={user.id}>
                  {getUserDisplayName(user)} - {user.role}
                </option>
              ))}
            </select>
            <p className="mt-1 text-xs text-gray-500">
              Assign inspection jobs to inspectors, admins, or property managers
            </p>
          </div>

          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700">Walkthroughs</label>
            <select
              name="walkthroughAssignedUserId"
              value={walkthroughAssignedUserId}
              onChange={onInputChange}
              className={selectStyles}
            >
              <option value="">Select a user</option>
              {walkthroughUsers.map((user) => (
                <option key={user.id} value={user.id}>
                  {getUserDisplayName(user)} - {user.role}
                </option>
              ))}
            </select>
            <p className="mt-1 text-xs text-gray-500">
              Assign walkthrough jobs to property managers or inspectors
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
